import React from 'react'

import SelectProjectMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/project-multi"
import FormManager from "../../../gd-form/common/form-manager"
import CustomView from "../../../model2/custom-view/custom-view"
import SelectUsersMulti from "../../../../app/quick-add/sections/view/components/forms/common-blocks/users-multi"
import quickAdd_getUsersIds from "../../../../app/quick-add/sections/view/components/forms/functions/get-users-ids"
import SelectOptionMulti
    from "../../../../app/quick-add/sections/view/components/forms/common-blocks/select-option-multi"
import SelectOption from "../../../../app/quick-add/sections/view/components/forms/common-blocks/select-option"
import getAvailableProjectsByViewType from "../../functions/get-available-projects"
import {EntityType} from "../../../gd/const/item";

enum DateRangeValue {
    THIS_WEEK   = 'this_week',
    LAST_WEEK   = 'last_week',
    R7_DAYS     = '7_days',
    R14_DAYS    = '14_days',
    R1_MONTH    = '1_month',
}

type WhatsDoneConditionsType = {
    projects    : ID[]
    users       : ID[]
    items       : {
        projects    : boolean
        tasks       : boolean
        events      : boolean
    }
    dateRange   : DateRangeValue
}

type Props = {
    className?  : string

    view        : CustomView
    disabled?   : boolean
    onChange    : { (conditions: WhatsDoneConditionsType):void }
}

// const debug = "ViewWhatsDone_Conditions"
const debug = false

export default function ViewWhatsDone_Conditions(props: Props) {

    debug && console.log(debug, 'render', props)

    const onUserChange = () => {
        debug && console.log(debug, 'onUserChange')

        const result = form.getValues()

        const items = {
            projects    : result.items.includes('projects'),
            tasks       : result.items.includes('tasks'),
            events      : result.items.includes('events'),
        }

        const conditions: WhatsDoneConditionsType = {
            projects    : result.projects,
            users       : result.users,
            items       : items,
            dateRange   : result.dateRange || DateRangeValue.R7_DAYS,
        }

        debug && console.log(debug, 'onUserChange conditions', conditions)

        props.onChange(conditions)
    }

    const updateUsersField = (name: string, allUserIds: ID[]) => {
        const users = form.getValue(name);
        const newUsers = _.intersection(users, allUserIds)
        form.setFieldValue(name, newUsers)
    }

    const onParentSelect = (projects: ID[]) => {
        debug && console.log(debug, 'onParentSelect')

        form.onFormComponentValueChange('projects', projects)
        const newUsers = quickAdd_getUsersIds(projects)

        updateUsersField('users', newUsers)

        onUserChange()
    }

    const conditions = props.view.settings

    const items = []
    if (conditions?.items?.projects)    items.push('projects')
    if (conditions?.items?.tasks)       items.push('tasks')
    if (conditions?.items?.events)      items.push('events')

    const initFormData: any = {
        projects    : conditions?.projects || [],
        users       : conditions?.users || [],
        items       : !_.isEmpty(items) ? items : ['projects', 'tasks', 'events'],
        dateRange   : conditions?.dateRange || DateRangeValue.R7_DAYS,
    }

    const formStructure = {
        fields          : {
            projects        : { type: 'select',   isRequired: false,  label: 'Projects'},
            users           : { type: 'select',   isRequired: false,  label: 'Users',                   onUserChange: onUserChange},
            items           : { type: 'select',   isRequired: false,  label: 'View type',               onUserChange: onUserChange,
                validator: (val:any) => {
                    return val.length > 0 ? true : 'At least one type should be selected'
                }
            },
            dateRange       : { type: 'select',   isRequired: true,   label: 'Date range',              onUserChange: onUserChange},
        },
        isFormChanged   : true,
    }

    const form = new FormManager(formStructure, initFormData)
    const projectsIds = form.getValue('projects') || []
    const usersIds = quickAdd_getUsersIds(projectsIds)

    const classes = Classes("ui5-form", props.className)

    const viewItemsOptions = [
        { value: 'projects',    label: 'Projects',  icon: '' },
        { value: 'tasks',       label: 'Tasks',     icon: '' },
        { value: 'events',      label: 'Events',    icon: '' },
    ]

    const dateRangeOptions = [
        { value: DateRangeValue.THIS_WEEK,  label: 'This week' },
        { value: DateRangeValue.LAST_WEEK,  label: 'Last week' },
        { value: DateRangeValue.R7_DAYS,    label: '7 days' },
        { value: DateRangeValue.R14_DAYS,   label: '14 days' },
        { value: DateRangeValue.R1_MONTH,   label: '1 month' },
    ]

    return (
        <div className={classes}>
            <div className="tbl">
                <SelectProjectMulti form                = {form}
                                    formFieldName       = 'projects'
                                    availableProjects   = {getAvailableProjectsByViewType(props.view.type)}
                                    disabled            = {props.disabled}
                                    parentsFor          = {EntityType.PROJECT}
                                    onParentSelect      = {onParentSelect}/>

                <SelectUsersMulti label                 = "Users"
                                  form                  = {form}
                                  formFieldName         = 'users'
                                  usersIds              = {usersIds}
                                  includeCurrentUser    = {true}
                                  disabled              = {props.disabled}/>

                <SelectOptionMulti label         = "View items"
                                   form          = {form}
                                   formFieldName = 'items'
                                   options       = {viewItemsOptions}/>

                <SelectOption label         = "Default date range"
                              form          = {form}
                              formFieldName = 'dateRange'
                              options       = {dateRangeOptions}/>
            </div>
        </div>
    )
}
